import { useInView } from "../../hooks/useInView";

const CARDS = [
  {
    title: "Secure & Protected",
    description:
      "Your information is safeguarded throughout the application process.",
  },
  {
    title: "Privacy First",
    description: "Your personal information is handled responsibly.",
  },
  {
    title: "Transparent & Clear",
    description:
      "Loan terms, applicable charges, and repayment details are clearly communicated.",
  },
];

export function SecuritySection() {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-16 sm:py-20">
      <div
        ref={ref}
        className={`flex flex-col items-center gap-4 text-center ${inView ? "in-view" : ""}`}
      >
        <span className="reveal-scroll delay-1 rounded-full bg-[#fef9c3] px-4 py-[6px] text-xs font-semibold uppercase tracking-[0.6px] text-[#854d0e]">
          Your Data. Your Privacy. Your Trust.
        </span>
        <h2 className="reveal-scroll delay-2 text-3xl font-extrabold leading-tight text-[#1c1917] sm:text-4xl">
          Security &amp; Privacy First
        </h2>
        <p className="reveal-scroll delay-3 max-w-[672px] text-base leading-7 text-[#475569]">
          We take the security of your personal and financial information
          seriously. Your information is handled securely and used in
          accordance with our privacy practices.
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-3">
        {CARDS.map((card, idx) => (
          <div
            key={card.title}
            className="reveal-scroll rounded-[20px] bg-[#1e293b] p-6"
            style={{
              animationDelay: `${0.4 + idx * 0.1}s`,
            }}
          >
            <h3 className="text-lg font-bold leading-6 text-white">
              {card.title}
            </h3>
            <p className="pt-3 text-sm leading-5 text-white/70">
              {card.description}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-6 rounded-2xl bg-[#1e293b] px-6 py-4">
        <p className="text-sm leading-5 text-white/80">
          <span className="font-bold text-white">Important Note:</span> Only
          use claims like &quot;encrypted,&quot; &quot;bank-grade
          security,&quot; &quot;RBI regulated,&quot; etc. if Genz Paisa can
          substantiate them.
        </p>
      </div>
    </section>
  );
}
